import isSiteExternal from "../../utils/isSiteExternal";
import { PASSPORT_WS_CORAL_CONFIG, CARRIER_LOGISTICS_WS_CONFIG, PASSPORT_URL_PREFIXES, CARRIER_LOGISTICS_URL_PREFIXES } from "./endpointConfig";
var getEnv = function() {
    var url = window.location.href;
    var env;
    if (url.includes(PASSPORT_URL_PREFIXES.BETA_URL_PREFIX)) {
        env = PASSPORT_WS_CORAL_CONFIG.BETA_CONFIG;
    } else if (url.includes(PASSPORT_URL_PREFIXES.GAMMA_URL_PREFIX)) {
        env = PASSPORT_WS_CORAL_CONFIG.GAMMA_CONFIG;
    } else if (url.includes(PASSPORT_URL_PREFIXES.PROD_URL_PREFIX)) {
        env = PASSPORT_WS_CORAL_CONFIG.PROD_CONFIG;
    } else if (url.includes(CARRIER_LOGISTICS_URL_PREFIXES.BETA_URL_PREFIX)) {
        env = CARRIER_LOGISTICS_WS_CONFIG.BETA_CONFIG;
    } else if (url.includes(CARRIER_LOGISTICS_URL_PREFIXES.GAMMA_URL_PREFIX)) {
        env = CARRIER_LOGISTICS_WS_CONFIG.GAMMA_CONFIG;
    } else if (url.includes(CARRIER_LOGISTICS_URL_PREFIXES.PROD_URL_PREFIX)) {
        env = CARRIER_LOGISTICS_WS_CONFIG.PROD_CONFIG;
    } else {
        if (isSiteExternal()) {
            env = CARRIER_LOGISTICS_WS_CONFIG.LOCAL_DEV;
        } else {
            env = PASSPORT_WS_CORAL_CONFIG.LOCAL_DEV;
        }
    }
    return env;
};
var envHelper = {
    getEnv: getEnv
};
export default envHelper;

//# sourceMappingURL=index.js.map